import { t } from '../../i18n/translations';
import {
    ACTION__MODAL__TAB__JOBS,
    ACTION__MODAL__TAB__JOBS__FOOD,
    ACTION__MODAL__TAB__POPULATION,
    ACTION__SETTLEMENT__HIRE_ASSISTANT,
    ACTION__SETTLEMENT__HIRE_FARMER,
    ACTION__SETTLEMENT__HIRE_HUNTER,
} from '../../engine/input/actionIds';
import type { TutorialContext, TutorialStep } from './types';
import { getActiveJobsTabId, getActiveModal } from './helpers';

const ASSISTANT_TARGET = 2;
const FARMER_TARGET = 2;
const HUNTER_TARGET = 2;

export function buildStarvationSteps(ctx: TutorialContext): TutorialStep[] {
    const { state, settlement, settlementTileId, lang } = ctx;
    return [
        {
            id: 'click-city',
            title: t(lang, 'tutorial.starvation.step1.title'),
            body: t(lang, 'tutorial.starvation.step1.body'),
            target: { type: 'tile', tileId: settlementTileId },
            allowActionIds: [],
            condition: () => state.activeModalId === settlementTileId,
        },
        {
            id: 'open-population',
            title: t(lang, 'tutorial.starvation.step2.title'),
            body: t(lang, 'tutorial.starvation.step2.body'),
            target: { type: 'action', actionId: ACTION__MODAL__TAB__POPULATION },
            allowActionIds: [ACTION__MODAL__TAB__POPULATION],
            condition: () => getActiveModal(state)?.activeTabId === ACTION__MODAL__TAB__POPULATION,
        },
        {
            id: 'open-jobs',
            title: t(lang, 'tutorial.starvation.step3.title'),
            body: t(lang, 'tutorial.starvation.step3.body'),
            target: { type: 'action', actionId: ACTION__MODAL__TAB__JOBS },
            allowActionIds: [ACTION__MODAL__TAB__JOBS],
            condition: () => getActiveModal(state)?.activeTabId === ACTION__MODAL__TAB__JOBS,
        },
        {
            id: 'open-food-jobs',
            title: t(lang, 'tutorial.starvation.step4.title'),
            body: t(lang, 'tutorial.starvation.step4.body'),
            target: { type: 'action', actionId: ACTION__MODAL__TAB__JOBS__FOOD },
            allowActionIds: [ACTION__MODAL__TAB__JOBS__FOOD],
            condition: () => getActiveJobsTabId(state) === ACTION__MODAL__TAB__JOBS__FOOD,
        },
        {
            id: 'hire-farmers',
            title: t(lang, 'tutorial.starvation.step5.title'),
            body: t(lang, 'tutorial.starvation.step5.body', FARMER_TARGET),
            target: { type: 'action', actionId: ACTION__SETTLEMENT__HIRE_FARMER },
            allowActionIds: [ACTION__SETTLEMENT__HIRE_FARMER],
            condition: () => (settlement ? settlement.jobs.farmers >= FARMER_TARGET : false),
        },
        {
            id: 'hire-hunters',
            title: t(lang, 'tutorial.starvation.step6.title'),
            body: t(lang, 'tutorial.starvation.step6.body', HUNTER_TARGET),
            target: { type: 'action', actionId: ACTION__SETTLEMENT__HIRE_HUNTER },
            allowActionIds: [ACTION__SETTLEMENT__HIRE_HUNTER],
            condition: () => (settlement ? settlement.jobs.hunters >= HUNTER_TARGET : false),
        },
        {
            id: 'hire-assistants',
            title: t(lang, 'tutorial.starvation.step7.title'),
            body: t(lang, 'tutorial.starvation.step7.body', ASSISTANT_TARGET),
            target: { type: 'action', actionId: ACTION__SETTLEMENT__HIRE_ASSISTANT },
            allowActionIds: [ACTION__SETTLEMENT__HIRE_ASSISTANT],
            condition: () => (settlement ? settlement.jobs.assistants >= ASSISTANT_TARGET : false),
        },
        {
            id: 'return-population',
            title: t(lang, 'tutorial.starvation.step8.title'),
            body: t(lang, 'tutorial.starvation.step8.body'),
            target: { type: 'action', actionId: ACTION__MODAL__TAB__POPULATION },
            allowActionIds: [ACTION__MODAL__TAB__POPULATION],
            condition: () => getActiveModal(state)?.activeTabId === ACTION__MODAL__TAB__POPULATION,
        },
    ];
}
